import { render, staticRenderFns } from "./VesselCourseUnknownCaution.vue?vue&type=template&id=10d6d708&"
import script from "./VesselCourseUnknownCaution.vue?vue&type=script&lang=js&"
export * from "./VesselCourseUnknownCaution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports